<div class="comp-menu">
	<div
		class="d-flex flex-nowrap justify-content-between align-items-center gap-3 py-3"
	>
		<p>{{ "choose_autotext" | langVal }}</p>
		@if (permsService?.perms?.administrative) {
			<button
				class="btn btn-icon btn-plus"
				(click)="modalProps = { name: 'insert-autotext' }"
				titleLang="add"
				icon="plus"
			></button>
		}
	</div>

	<div class="items">
		<div class="d-flex gap-3 align-items-center px-2">
			@if (permsService?.perms?.administrative) {
				<app-icon
					[icon]="showAll ? 'narrow' : 'expand'"
					(click)="flipShowAll()"
				/>
			}
			<app-gen-input
				[actualObj]="this"
				fieldName="search"
				(keyupEvent)="handleSearch()"
				class="flex-grow-1"
			/>
		</div>

		@if (!search) {
			<div class="tests-autotext-menu-list d-flex flex-column status">
				<div class="d-flex flex-nowrap align-items-center gap-3">
					<app-icon
						icon="expand"
						(click)="modalProps = { name: 'status' }"
					/>
					<div
						(click)="modalProps = { name: 'status' }"
						class="colstat-small-triple"
					>
						{{ "status" | langVal }}
					</div>
				</div>
			</div>
		}
		@for (autotext of dispRows; track autotext.id) {
			<div class="tests-autotext-menu-list d-flex flex-column">
				<div class="d-flex flex-nowrap gap-3">
					<div>
						@if (permsService?.perms?.administrative) {
							<app-icon
								[icon]="autotext.showText ? 'narrow' : 'expand'"
								(click)="autotext.showText = !autotext.showText"
							/>
						}
					</div>
					<div
						(click)="onClose.emit(autotext.html_autotext)"
						class="colstat-small-triple"
					>
						{{ autotext.name }}
					</div>
					<div class="text-end colstat-small">
						@if (permsService?.perms?.administrative) {
							<app-icon
								icon="settings1"
								(click)="
									modalProps = { name: 'insert-autotext', autotext: autotext };
									$event.stopImmediatePropagation()
								"
							/>
						}
					</div>
				</div>
				@if (autotext.showText) {
					<div class="pt-3">
						<app-wysiwyg
							#descriptionWysiwyg
							[actualObj]="autotext"
							fieldName="html_autotext"
							tabindex="1"
							(changeEvent)="saveField(autotext)"
							title_ph_lang="html_autotext"
							[initHeight]="
								eventsService.isMobile ? eventsService.MobileHeight - 610 : 0
							"
						/>
					</div>
				}
			</div>
		}
	</div>
</div>
@switch (modalProps?.name) {
	@case ("insert-autotext") {
		<app-modal-wrap
			(onClose)="modalProps = null; getRows()"
			modalWrapperClass="modal-650"
			title="autotext"
		>
			<app-insert-autotext
				(onClose)="modalProps = null; getRows()"
				[autotext]="modalProps.autotext"
			/>
		</app-modal-wrap>
	}
	@case ("status") {
		<app-modal-wrap
			(onClose)="onClose.emit()"
			title="status"
		>
			<app-status (onClose)="onClose.emit($event)" />
		</app-modal-wrap>
	}
}
